import classNames from 'classnames';
import { ForgeButton, ForgeIcon, ForgeIconButton } from '@tylertech/forge-react';

import Actions from 'Actions';
import { I18n } from 'common/i18n';
import StorytellerUtils from 'lib/StorytellerUtils';
import { isFlexibleStory } from 'lib/FlexibleLayoutUtils';
import { ComponentType } from 'types';

import { type ReactRendererProps } from '../../shared/ComponentRegistry';

const FlexibleInsertButton = () => (
  <ForgeIconButton
    data-action={Actions.ASSET_SELECTOR_SELECT_ASSET_FOR_COMPONENT}
    aria-label={I18n.t('editor.components.asset_selector.select_btn')}
    className="forge-icon-button"
  >
    <ForgeIcon name="add" />
  </ForgeIconButton>
);

const ClassicInsertButton = () => (
  <div className="insert-button-container" data-action={Actions.ASSET_SELECTOR_SELECT_ASSET_FOR_COMPONENT}>
    <ForgeButton className="asset-selector-insert-btn" variant="filled">
      {I18n.t('editor.components.asset_selector.insert_btn')}
    </ForgeButton>
  </div>
);

/**
 * React component renderer for asset selector components. Renders the button that
 * opens the asset selector to insert media or a visualization into a block.
 */
export const ComponentAssetSelector = ({ componentData, editMode }: ReactRendererProps) => {
  if (!editMode) {
    return null;
  }

  const typeForClasses =
    componentData.type === ComponentType.CLASSIC_VIZ ? ComponentType.ASSET_SELECTOR : componentData.type;
  const typeClasses = StorytellerUtils.typeToClassesForComponentType(typeForClasses);
  const flexible = isFlexibleStory();

  const className = classNames('component', typeClasses, {
    rendered: flexible,
    'no-asset-insert': flexible,
    'component-asset-selector-flexible': flexible,
  });

  return <div className={className}>{flexible ? <FlexibleInsertButton /> : <ClassicInsertButton />}</div>;
};
